// extracted by mini-css-extract-plugin
export default {"root":"hstack_root__ruCBz","top":"hstack_top__oUH8Y","center":"hstack_center__+bYzs","bottom":"hstack_bottom__54IOj"};